<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">Personnels soignants</div>
    <div class="modal-body">
      <div class="tabs-header">
        <div id="internal-tab" class="tab  active" (click)="showTab($event)" title="Personnel interne à la structure"></div>
        <div id="linked-patient-tab" class="tab" [ngClass]="{ 'inactive': patientsId.length === 0 }" (click)="patientsId.length > 0 ? showTab($event) : null" title="Intervenant externe lié au patient"></div>
        <div id="external-tab" class="tab" (click)="showTab($event)" title="Autre intervenant"></div>
      </div>
      <div id="tabs-content">
        <div id="tab-1" class="hidden-tab shown-tab">
          <frg-form-input *ngIf="formGroupInternal"
            id="name"
            label="Personnel interne à la structure"
            [selectValue]="resourcesStr"
            type="ngSelect"
            [formGroup]="formGroupInternal"
            [control]="formGroupInternal.get('name')"
            isMultiSelect="true"
            closeOnSelect="false"
            (modelChanged)="modelChanged($event)"
            isParentModal="true"
          ></frg-form-input>
        </div>
        <div id="tab-2" class="hidden-tab" [ngClass]="{ 'inactive': patientsId.length === 0 || resourcesLinkedToPatientsStr.length === 0 }">
          <frg-form-input *ngIf="formGroupLinkedPatients && resourcesLinkedToPatientsStr.length > 0"
            id="name"
            label="Intervenant externe lié au patient"
            [selectValue]="resourcesLinkedToPatientsStr"
            type="ngSelect"
            [formGroup]="formGroupLinkedPatients"
            [control]="formGroupLinkedPatients.get('name')"
            isMultiSelect="true"
            closeOnSelect="false"
            (modelChanged)="modelChangedLinkedToPatients($event)"
            isParentModal="true"
          ></frg-form-input>
          <div class="no-resource" *ngIf="!formGroupLinkedPatients || resourcesLinkedToPatientsStr.length === 0">Aucun intervenant à afficher</div>
        </div>
        <div id="tab-3" class="hidden-tab">
          <frg-form-input *ngIf="formGroupExternal"
            id="title"
            type="text"
            label="Autre intervenant"
            [formGroup]="formGroupExternal"
            [control]="formGroupExternal.get('name')"
          ></frg-form-input>
        </div>
      </div>
      <div class="buttons-wrapper">
        <frg-button (activated)="doCancel()" [backgroundColor]="'var(--darkest-primary)'">Annuler</frg-button>
        <frg-button (activated)="doSave()" [ngClass]="{ 'inactive': ((currentFolderId === 'internal-tab' || currentFolderId === 'linked-patient-tab') && selectedCaregivers.length === 0) || (currentFolderId === 'external-tab' && (!formGroupExternal || !formGroupExternal.get('name').value || formGroupExternal.get('name').value === '')) }">Valider</frg-button>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>